import { render, staticRenderFns } from "./statsInvoicesCounters.vue?vue&type=template&id=2a466cca&"
import script from "./statsInvoicesCounters.vue?vue&type=script&lang=js&"
export * from "./statsInvoicesCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports